<template>
    <div class="map-container">
        <el-input type="text" v-model="selectedLocation" readonly placeholder="点击选择位置">
            <el-button @click="showMap" size="mini" slot="append" icon="el-icon-map-location"></el-button>

        </el-input>

        <div v-if="dialogVisible" class="mask"></div> <!-- 添加蒙版 -->

        <div v-if="dialogVisible" class="map-dialog">
            <div style="display: flex;align-items: center; justify-content: space-between;">
                <h3>{{ header }}</h3>
                <div style="display: flex;justify-content: center;">
                    <div v-if="!disabled" style="margin-right: 10px;">
                        <el-button v-if="!isDrawing" type="primary" @click="startDrawing">开始绘制折线</el-button>
                        <el-button v-else @click="finishDrawing">完成绘制</el-button>
                        <el-button @click="clearDrawing">清除</el-button>
                    </div>
                    <el-button @click="cancelSelection">取消</el-button>
                </div>
            </div>

            <div id="amap"
                style="width: 100%; height: 530px; border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);background-color: #fff;">
            </div>
            <div class="map-controls">
                <!-- <el-button v-if="!isDrawing" type="primary" @click="startDrawing">开始绘制折线</el-button>
                <el-button v-else @click="finishDrawing">完成绘制</el-button>
                <el-button @click="clearDrawing">清除</el-button>
                <el-button @click="cancelSelection">取消</el-button> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MyMap',
    props: {
        initialLine: {
            type: String,
            default: ''
        },
        header: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            map: null,
            polyline: null,
            points: [],
            markers: [],
            dialogVisible: false,
            selectedLocation: this.initialLine || '',
            isDrawing: false,
            index: 0,
            pointsNum: 0,
        };
    },
    mounted() {
    },
    methods: {
        showMap() {
            this.dialogVisible = true;
            this.polyline = null;
            this.index = 0;
            this.pointsNum = 0;
            this.$nextTick(() => {
                this.initMap();
            });
        },
        initMap() {
            console.log('start', this.polyline)
            this.map = new AMap.Map('amap', {
                zoom: 11,
                center: this.initialLine ? [parseFloat(this.initialLine.split(';')[0].split(',')[0]), parseFloat(this.initialLine.split(';')[0].split(',')[1])] : [117.0702181, 36.6663163], // 默认中心点位置
            });

            if (this.initialLine) {
                this.points = this.initialLine.split(';').map(point => ({
                    lng: parseFloat(point.split(',')[0]),
                    lat: parseFloat(point.split(',')[1]),
                }));
                this.drawPolyline(this.points);
                this.pointsNum = this.points.length;
                this.points.map(point => {
                    this.addMarker(point);
                })
            }

            this.map.on('click', (e) => {
                if (this.isDrawing) {
                    const point = {
                        lng: e.lnglat.lng,
                        lat: e.lnglat.lat,
                    };
                    this.points.push(point);
                    this.updatePolyline(this.points);
                    this.addMarker(point);
                }
            });
        },
        drawPolyline(points) {
            console.log('draw', points);
            if (!this.polyline) {
                this.polyline = new AMap.Polyline({
                    path: points.map(point => [point.lng, point.lat]),
                    isOutline: true,
                    outlineColor: '#ffeeee',
                    borderWeight: 2,
                    strokeColor: "#3366FF",
                    strokeOpacity: 1,
                    strokeWeight: 3,
                    strokeStyle: "dashed",
                    strokeDasharray: [10, 5],
                    lineJoin: 'round',
                });
                this.polyline.setMap(this.map);
            } else {
                this.polyline.setPath(points.map(point => [point.lng, point.lat]));
            }
        },
        updatePolyline(points) {
            // if (this.disabled) return;
            if (this.polyline) {
                this.polyline.setPath(points.map(point => [point.lng, point.lat]));
            } else {
                this.drawPolyline(points);
            }
        },
        addMarker(point) {
            let src = null;
            if (this.index === 0) src = 'http://webapi.amap.com/theme/v1.3/markers/n/start.png';
            else if (this.index === this.pointsNum - 1) src = 'http://webapi.amap.com/theme/v1.3/markers/n/end.png';
            else src = 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png';
            this.index++;
            const marker = new AMap.Marker({
                position: [point.lng, point.lat],
                map: this.map,
                icon: new AMap.Icon({
                    size: new AMap.Size(25, 36),
                    image: src,
                    imageSize: new AMap.Size(25, 36),
                }),
            });
            this.markers.push(marker);
        },
        startDrawing() {
            this.isDrawing = true;
        },
        finishDrawing() {
            if (this.points.length < 2) {
                this.$message.error('请至少选择两个点');
                return;
            }
            if (this.points.length > 16) {
                this.$message.error('请至多选择十六个点');
                return;
            }
            this.selectedLocation = this.points.map(point => `${point.lng},${point.lat}`).join(';');
            this.$emit('line-selected', this.selectedLocation);
            this.dialogVisible = false;
            this.isDrawing = false;
            this.points = [];
            this.clearMarkers();
            this.clearPolyline();
        },
        cancelSelection() {
            this.dialogVisible = false;
            this.isDrawing = false;
            this.points = [];
            this.clearMarkers();
            this.clearPolyline();
            this.$emit('cancel-selection');
        },
        clearMarkers() {
            this.markers.forEach(marker => {
                marker.setMap(null);
            });
            this.markers = [];
        },
        clearPolyline() {
            if (this.polyline) {
                this.polyline.setMap(null);
                this.polyline = null;
            }
        },
        clearDrawing() {
            this.selectedLocation = null;
            this.$emit('line-selected', this.selectedLocation);
            this.points = [];
            this.clearMarkers();
            this.clearPolyline();
        }
    },
    watch: {
        initialLine(newVal) {
            if (newVal) {
                console.log('map-line')
                this.selectedLocation = newVal;
                let data = newVal.split(';').map(point => ({
                    lng: parseFloat(point.split(',')[0]),
                    lat: parseFloat(point.split(',')[1]),
                }));
                this.updatePolyline(data);
                data.map(point => this.addMarker(point))
            } else if (this.initialLine) {

            } else {
                this.selectedLocation = null;
                this.clearMarkers();
                this.clearPolyline();
            }
        },
    },
};
</script>
<style scoped>
.map-dialog {
    position: fixed;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -10%);

    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;

    height: 600px;
    width: 1100px;
    border-radius: 10px;
}

.map-container {
    position: relative;
}

.map-controls {
    position: absolute;
    bottom: 10px;
    right: 20px;
    z-index: 1000;
}

.mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 10;
    /* 确保在弹出框下方 */
    display: block;
    /* 显示蒙版 */
}
</style>